import React from 'react';
import { Link } from 'react-router-dom';
import backgroundImage from '../assets/background.jpg'; // Adjust the path based on your folder structure
import blogImage5 from '../assets/blog5.webp';  // Blog post image 1
import blogImage6 from '../assets/blog6.jpg';  // Blog post image 2
import blogImage7 from '../assets/blog7.jpg';  // Blog post image 3
import blogImage4 from '../assets/blog4.jpg';
import blogImage8 from '../assets/blog8.jpg'; 

// Sample blog post data
const blogPosts = [
  {
    id: 1,
    title: 'Custom Software Development: Tailored Solutions for Your Business Needs',
    // excerpt: 'Learn about how Sigma IT Innovation transformed businesses with cutting-edge technology solutions and IT consultancy.',
    content: 'The world of Information Technology (IT) has experienced a rapid transformation over the past decade, and businesses today are in the midst of a digital revolution. Traditional IT solutions no longer meet the dynamic needs of modern organizations. At Gravionix technologies, we recognized this shift early and set out to revolutionize how IT solutions are developed, deployed, and integrated into businesses.',
    date: 'January 10, 2025',
    image: blogImage5, // Fixed to use import
    slug: 'how-we-revolutionized-it-solutions',
    author: 'Ravi Kumar',
  },
  {
    id: 2,
    title: 'How Gravionix technologies is Shaping the Future of Technology',
    // excerpt: 'Discover the role artificial intelligence will play in the future of business, from automation to data-driven decisions.',
    content: 'In today’s rapidly evolving digital world, businesses must stay ahead of the curve to remain competitive. At Gravionix technologies, we are doing more than just keeping up with the trends—we are actively shaping the future of technology. By pioneering new solutions and pushing the boundaries of what’s possible, we are enabling businesses across industries to thrive in an connected. ',
    date: 'January 5, 2025',
    image: blogImage8, // Fixed to use import
    slug: 'future-of-ai-in-business',
    author: 'Priya Sharma',
  },
  {
    id: 3,
    title: 'Cybersecurity in the Digital Age: Protecting Your Business with Gravionix technologies',
    // excerpt: 'Cybersecurity is more important than ever. Find out why your business should invest in strong cyber defense systems.',
    content: 'As businesses become increasingly reliant on digital technologies, the importance of robust cybersecurity measures cannot be overstated. The rapid growth of the internet, cloud computing, and digital services has opened up countless opportunities for businesses, but it has also created new vulnerabilities, Cyber threats have become more sophisticated.',
    date: 'December 28, 2024',
    image: blogImage7, // Fixed to use import
    slug: 'importance-of-cybersecurity',
    author: 'Anjali Reddy',
  },
  // {
  //   id: 4,
  //   title: 'The Future of Blockchain: Beyond Cryptocurrency',
  //   // excerpt: 'Dive deep into blockchain and how it’s transforming industries like finance, healthcare, and logistics.',
  //   content: 'Blockchain technology has garnered significant attention as the underlying architecture for cryptocurrencies like Bitcoin and Ethereum. While cryptocurrencies remain one of the most well-known applications of blockchain, the potential of this technology goes far beyond digital currencies. Today, blockchain is emerging as a transformative force that is poised to revolutionize various industries, offering solutions to some of the most persistent challenges Sigma IT Innovation bussiness face today.  ',
  //   date: 'January 15, 2025',
  //   image: blogImage6, // Added the fourth image
  //   slug: 'understanding-blockchain-technology',
  //   author: 'Suresh Iyer',
  // },
];

const Blog = () => {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="flex flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          height: '50vh',
        }}
      >
        <div className="flex flex-col items-center justify-center text-center py-10">
          <h6 className="text-xl font-normal text-white">Gravionix technologies</h6>
          <h1 className="text-5xl font-bold text-white">Our Blogs</h1>
        </div>

        <div className="mt-8">
          <nav className="flex space-x-6">
            <Link to="/" className="text-lg text-blue-500 hover:text-blue-700">
              Home
            </Link>
            <span className="text-lg text-blue-500">/</span> {/* Dash between links */}
            <Link to="/blog" className="text-lg text-blue-500 hover:text-blue-700">
              Blog
            </Link>
          </nav>
        </div>
      </div>

      {/* Short News Section */}
      <section className="bg-gray-100 py-16">
      <div className="container mx-auto px-6 flex flex-col sm:flex-row items-center gap-8">
        {/* Image Section */}
        <div className="w-full sm:w-1/3">
          <img
            src={blogImage4} // Using the image from the assets folder
            alt="Tech Advancements"
            className="w-full h-96 object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Text Section */}
        <div className="w-full sm:w-2/3">
          <h2 className="text-3xl sm:text-4xl font-semibold text-blue-800 mb-4">
            Latest News: Tech Advancements
          </h2>
          <div className="flex items-center text-sm text-gray-500 mb-4">
            <span>January 16, 2025</span> | <span className="ml-2">By Shraddha Aarya</span>
          </div>

          <p className="text-lg sm:text-xl text-gray-700 mb-4">
          Gravionix technologies has made remarkable progress in the last quarter, with new breakthroughs in IT solutions. We continue to push boundaries to bring cutting-edge technology to the forefront of industries.
          </p>
          <p className="text-lg sm:text-xl text-gray-700 mb-4">
            With the continuous integration of artificial intelligence and machine learning into our systems, we're providing more efficient solutions for businesses, enhancing operational productivity and decision-making capabilities.
          </p>
          <p className="text-lg sm:text-xl text-gray-700 mb-4">
            As we focus on cybersecurity, we’ve been strengthening our internal systems to protect both our clients and our business. Expect more innovative solutions in the upcoming months.
          </p>
          <p className="text-lg sm:text-xl text-gray-700 mb-4">
            Stay tuned for more updates as we continue our mission to revolutionize the tech industry!
          </p>

          {/* <Link
            to="/blog"
            className="inline-block bg-blue-800 text-white py-2 px-6 rounded-full hover:bg-blue-600 transition duration-300"
          >
            Read More
          </Link> */}
        </div>
      </div>
    </section>

    <section className="bg-gray-100 py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-12">
            {blogPosts.map((post) => (
              <div key={post.id} className="flex flex-col bg-white rounded-lg shadow-lg overflow-hidden">
                {/* Post Image */}
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-56 object-cover rounded-t-lg mb-6"
                />

                <div className="p-6">
                  {/* Post Title */}
                  <h2 className="text-2xl font-semibold text-blue-800 mb-4">{post.title}</h2>

                  {/* Post Excerpt */}
                  <p className="text-gray-700 mb-4">{post.excerpt}</p>

                  {/* New Paragraph */}
                  <p className="text-gray-600 mb-6">
                    {post.content || "This blog post explores the deeper insights into technology and innovation in the modern age. Stay ahead with our detailed coverage of key trends that shape industries today."}
                  </p>

                  {/* Post Date & Author */}
                  <div className="flex justify-between items-center text-sm text-gray-500 mb-6">
                    <span>{post.date}</span>
                    <span>By {post.author}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
